"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[8831],{

/***/ 92949:
/***/ ((module) => {

module.exports = {"id":"cloudwatch"};

/***/ })

}]);